// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._11eY05l0gVsaAIkGZuj-oO {\n    position: relative;\n}\n\n._11eY05l0gVsaAIkGZuj-oO:before,\n._11eY05l0gVsaAIkGZuj-oO:after {\n    visibility: hidden;\n    pointer-events: none;\n}\n\n._11eY05l0gVsaAIkGZuj-oO:hover:after,\n._11eY05l0gVsaAIkGZuj-oO:hover:before {\n    visibility: visible;\n}\n\n._11eY05l0gVsaAIkGZuj-oO:before {\n    background-color: #32445A;\n    border-radius: 3px;\n    border: 1px solid white;\n    color: white;\n    content: attr(data-tooltip);\n    font-size: 12px;\n    line-height: 1.5;\n    padding: 5px 3px 5px 8px;\n    position: absolute;\n    transform: translateY(-100%);\n    width: 196px;\n}\n", ""]);
// Exports
exports.locals = {
	"tooltip": "_11eY05l0gVsaAIkGZuj-oO"
};
module.exports = exports;
